export function ErrorPage() {
  return (
    <img
      src="https://thumbor.forbes.com/thumbor/711x476/https://blogs-images.forbes.com/zarastone/files/2017/05/Waffles-The-Dog-Amazon-1200x804.jpg?width=960"
      alt="Error"
    />
  );
}
